module.exports = __webpack_public_path__ + "img/03.40823825.png";